import React from 'react';
import styled from 'styled-components';

const BackgroundInner = styled.div`
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
`;

const NullPage = () => {
    return <BackgroundInner></BackgroundInner>;
};

export default NullPage;
